import React from 'react';
import { SortOrder } from '../../generated/graphql';
import { HoverableBox } from '../Containers';
import { ChevronDownIcon, ChevronUpIcon } from '../SVGIcons';
import { getNextOrdering } from './utils';

interface TableHeadSortToggleProps {
    sort: string | false;
    setSort(q: string | false): void;
    isDisabled?: boolean;
}

const TableHeadSortToggle = ({ setSort, sort, isDisabled }: TableHeadSortToggleProps) => {
    const onReorderClick = () => {
        if(isDisabled){
            return;
        }

        const currentSortOrder = !!sort && sort as SortOrder;
        const nextSort = getNextOrdering(currentSortOrder);
        setSort(nextSort);
    };

    return (
        <HoverableBox
            isDisabled={isDisabled}
            onClick={onReorderClick}
            display='flex'
            fontSize={12}
            flexDirection='column'
        >
            <ChevronDownIcon color={sort === SortOrder.Desc ? 'primary' : 'disabled'} fontSize='inherit' />
            <ChevronUpIcon color={sort === SortOrder.Asc ? 'primary' : 'disabled'} fontSize='inherit' />
        </HoverableBox>
    );
};

export default TableHeadSortToggle;